let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lCNJg")).then(() => parcelRequire('6psOp'));